import React, { useCallback, useMemo } from "react";
import { Grid } from "semantic-ui-react";
import PlusIcon from "../../../../assets/commonIcon/PlusIcon";
import { CommonTable, CustomButton, DropDown, InputText } from "../../../../components";
import { InputNumber } from "../../../../components/InputText/InputNumber";
import { ProductUnitTable, UNIT_TYPES } from "../../../../config/constants";
import { validateDecimalNumber } from "../../../../utils/utils";
import { ProductUnitFormProps } from "../types/productTypes";
import { loadTableData } from "./UnitSizeTable";

const ProductUnitForm: React.FC<ProductUnitFormProps> = ({
  addProductUnit,
  defaultType,
  setDefaultType,
  enableSizeEditStatus,
  enableSizeEdit,
  setUnitSizeUpdate,
  editUnitSize,
  addUnitData,
  setDeleteData,
  setVisibleDeleteModal,
  registerUnitSize,
  controlUnitSize,
  errorsUnit,
  handleSubmitUnitSize,
  enableUnitSizeAdd
}) => {
  const deleteUnitValue = (data: any, status: boolean) => {
    setDeleteData(data);
    setVisibleDeleteModal(status);
  };

  const existingUnitNames = useMemo(
    () => addProductUnit.map(u => u.sales_unit_name.trim().toLowerCase()),
    [addProductUnit]
  );

  const validateUnitName = useCallback(
    (value: string) => {
      const clean = value.trim().toLowerCase();

      if (clean?.length > 20) {
        return "Maximum 20 characters allowed";
      }

      const isDuplicate = existingUnitNames.some((existingUnit, index) => {
        if (
          enableSizeEditStatus &&
          enableSizeEdit &&
          addProductUnit[index]?._id === enableSizeEdit._id
        ) {
          return false;
        }
        return existingUnit === clean;
      });

      if (isDuplicate) {
        return "Unit name already exists.";
      }

      return true;
    },
    [existingUnitNames, enableSizeEditStatus, enableSizeEdit, addProductUnit]
  );

  return (
    <>
      <Grid>
        <Grid.Column width={16} className="userBankDetailsMain">
          <Grid>
            <Grid.Column computer={3} tablet={8} mobile={16}>
              <InputText
                register={(name: string, options: any) =>
                  registerUnitSize(name, {
                    ...options,
                    validate: validateUnitName
                  })
                }
                errors={errorsUnit.sales_unit_name}
                labelName={"Unit Name*"}
                placeholder="Unit Name"
                name="sales_unit_name"
                required
                errorMessage="Unit name is required"
              />
            </Grid.Column>
            <Grid.Column computer={3} tablet={8} mobile={16}>
              <InputNumber
                transform={{
                  input: (value: any) => (isNaN(value) || value === 0 ? "" : value.toString()),
                  output: (e: any) => {
                    return e;
                  }
                }}
                control={controlUnitSize}
                errors={errorsUnit.sales_unit_size}
                labelName="Unit Size*"
                placeholder="Unit Size"
                name="sales_unit_size"
                required
                errorMessage="Unit size is required"
                customInputValidation={true}
                otherValidation={{
                  validate: {
                    valueCheck: (v: any) => validateDecimalNumber(v)
                  }
                }}
              />
            </Grid.Column>
            <Grid.Column computer={3} tablet={8} mobile={16}>
              <DropDown
                labelName={"Unit Type"}
                placeholder="Type"
                currentData={UNIT_TYPES}
                defaultValue={defaultType}
                customGridColumn={"customGridColomnType"}
                handleChangeState={(e: any, { value }: any) => {
                  setDefaultType(value);
                }}
              />
            </Grid.Column>
            <Grid.Column computer={4} tablet={8} mobile={16}>
              <InputText
                register={registerUnitSize}
                errors={errorsUnit.ean_barcode}
                labelName={"EAN Barcode"}
                placeholder="EAN Barcode"
                name="ean_barcode"
              />
            </Grid.Column>

            <Grid.Column computer={3} tablet={8} mobile={16}>
              {enableSizeEditStatus ? (
                <CustomButton
                  theme="green"
                  customColumnStyle={"addUnitSize"}
                  title="UPDATE"
                  onClick={handleSubmitUnitSize((data: any) => {
                    editUnitSize(data);
                  })}
                />
              ) : enableUnitSizeAdd ? (
                <CustomButton
                  theme="green"
                  customColumnStyle={"addUnitSize"}
                  icon
                  iconChild={<PlusIcon />}
                  customBase="productUnitAddButton"
                  onClick={handleSubmitUnitSize((data: any) => {
                    addUnitData(data);
                  })}
                />
              ) : null}
            </Grid.Column>
          </Grid>
          {addProductUnit.length > 0 && (
            <Grid.Column computer={16} tablet={16} mobile={16} className="productRegisterTable">
              <CommonTable tableHeaderData={ProductUnitTable}>
                {loadTableData(addProductUnit, deleteUnitValue, setUnitSizeUpdate, setDefaultType)}
              </CommonTable>
            </Grid.Column>
          )}
        </Grid.Column>
      </Grid>
    </>
  );
};

export default ProductUnitForm;
